import state from './modulePaymentListState'
import mutations from './modulePaymentListMutations'
import actions from './modulePaymentListActions'
import getters from './modulePaymentListGetters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
